<template>
    <ProLink
        class="insight-link-tile"
        :class="{ 'insight-link-tile--text-only': textOnly }"
        :aria-label="`${article.title} – ${article.category.title} – posted on: ${formatMonthDayYear(article.display_date)}`"
        :to="{ name: 'insight-year-slug', params: { year: formatYear(article.display_date), slug: article.slug } }"
        :title="`${article.category.title} - ${article.title}`"
    >
        <div
            v-if="!textOnly"
            class="insight-link-tile__image"
            aria-hidden="true"
            :style="{
                'background-image': `url('https://optimised.savage.si/format:jpg,width:1000/${article.image}')`,
                'background-color': article.cover_hex,
                color: `${article.cover_hex}40`,
            }"
        ></div>
        <div class="insight-link-tile__copy" aria-hidden="true">
            <div class="insight-link-tile__meta">
                <span :style="{ color: article.category.hex }">{{ article.category.title }}</span>
                <span>{{ formatMonthDayYear(article.display_date) }}</span>
            </div>
            <h3 class="insight-link-tile__title text-heading text-heading--xs">{{ article.title }}</h3>
        </div>
    </ProLink>
</template>

<script>
import { parseISO, format } from "date-fns";

export default {
    props: {
        article: Object,
        textOnly: Boolean,
    },

    methods: {
        formatMonthDayYear(date) {
            return format(parseISO(date), "MMMM d',' yyyy");
        },

        formatYear(date) {
            return parseISO(date).getFullYear();
        },
    },
};
</script>
